import { render, staticRenderFns } from "./TasksEdit.vue?vue&type=template&id=232d7dd6&"
import script from "./TasksEdit.vue?vue&type=script&lang=js&"
export * from "./TasksEdit.vue?vue&type=script&lang=js&"
import style0 from "./TasksEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports